// G-P10 (privacy register §19.1): the respondent privacy notice's public address,
// in one place. The invitation template (supabase/templates/invite.html, applied in
// the production dashboard at RUNBOOK_F7_ACTIVATION step 2e) carries the same
// address. Kenneth, 2026-10-25: the notice V1.3 is published at this address (G-P10 closed).
export const PRIVACY_NOTICE_URL = "https://www.linnfoss.com/assessment";
